/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Store} from '@gongxigames/framework/core';
import {Container, Point} from 'pixi.js';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {FC, CanBeSignals, getProp, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

type SlidesPresentationProps = CanBeSignals<{
    activeIndex: number;
    slidesPosition: Point;
} & {slides: Container[];}>;

export const $SlidesPresentation: FC<SlidesPresentationProps> = (props) => {
    const slides = getProp(props.slides);
    if (slides.length === 0) {
        return <></>;
    }

    const tweenAlphaTime = LSViewConfig.slidesParams.tweenAlphaTime;

    let prevSlide: Container | undefined = undefined;

    const currentSlide = Store.computed(() => {
        const slides = getProp(props.slides);
        const activeIndex = getProp(props.activeIndex);
        const slide = slides[activeIndex];

        if (prevSlide) {
            slide.alpha = 0;
        }

        prevSlide = slide;
        slotStore.updateManager.value!.addTween(slide)
            .to({alpha: 1}, tweenAlphaTime)
            .start();

        return slide;
    });

    return <$Container position={props.slidesPosition} name='SlideView'>{currentSlide}</$Container> as Container;;
};
